import { List } from 'immutable';
const isMissingGate = (userGates, accessControl) => accessControl.get('requireGate') && !userGates.includes(accessControl.get('requireGate')) || accessControl.get('requireAnyGate') && !accessControl.get('requireAnyGate').some(gate => userGates.includes(gate)) || accessControl.get('requireAllGates') && !accessControl.get('requireAllGates').every(gate => userGates.includes(gate)) || false;
const isMissingScope = (userScopes, accessControl) => accessControl.get('requireScope') && !userScopes.includes(accessControl.get('requireScope')) || accessControl.get('requireAnyScope') && !List(accessControl.get('requireAnyScope')).some(scope => userScopes.includes(scope)) || accessControl.get('requireAllScopes') && !List(accessControl.get('requireAllScopes')).every(scope => userScopes.includes(scope)) || false;
const hasForbiddenGate = (userGates, accessControl) => accessControl.get('forbiddenGate') && userGates.includes(accessControl.get('forbiddenGate')) || false;
const hasForbiddenScope = (userScopes, accessControl) => accessControl.get('forbiddenScope') && userScopes.includes(accessControl.get('forbiddenScope')) || false;
export const checkAccessControl = ({
  gates,
  scopes,
  accessControl
}) => {
  if (accessControl.get('neverShow')) {
    return false;
  }
  if (accessControl.get('requireAnyCombination')) {
    return accessControl.get('requireAnyCombination').some(access => checkAccessControl({
      gates,
      scopes,
      accessControl: access
    }));
  }
  return !isMissingGate(gates, accessControl) && !hasForbiddenGate(gates, accessControl) && !isMissingScope(scopes, accessControl) && !hasForbiddenScope(scopes, accessControl);
};
export const checkAccessRequirements = ({
  gates,
  scopes,
  accessControl
}) => {
  const visibilityControl = accessControl.get('visibilityControl');
  const isVisible = visibilityControl ? checkAccessControl({
    gates,
    scopes,
    accessControl: visibilityControl
  }) : true;
  const accessAllowed = checkAccessControl({
    gates,
    scopes,
    accessControl
  });
  return {
    isVisible,
    accessAllowed: accessAllowed && isVisible
  };
};